import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { tap } from 'rxjs/operators';

import { MfaEngageDialogController } from 'dialog/mfa-engage-dialog/mfa-engage-dialog.controller';
import { MfaEngageDialogStore } from 'dialog/mfa-engage-dialog/mfa-engage-dialog.store';
import { UserMfaEngageOutput } from 'user/model/user-mfa-engage.output';

@Component({
	selector: 'spr-mfa-engage-dialog',
	templateUrl: './mfa-engage-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [MfaEngageDialogStore, MfaEngageDialogController],
	host: {
		class: 'flex flex-col items-stretch space-y-3',
	},
})
export class MfaEngageDialogComponent {
	public mfaCode: string;
	public mfaEngage: UserMfaEngageOutput;

	constructor(
		private _config: DynamicDialogConfig,
		private _dialogRef: DynamicDialogRef,
		public controller: MfaEngageDialogController
	) {
		this.mfaEngage = _config.data as UserMfaEngageOutput;
	}

	public onMfaCodeSubmit() {
		this.controller
			.validateMfaCode(this.mfaCode)
			.pipe(tap(() => this._dialogRef.close()))
			.subscribe();
	}

	public isMfaCodeInvalid(): boolean {
		return !this.mfaCode || this.mfaCode.length !== 6;
	}
}
